import { observable } from 'mobx';

export default class AgentProfileViewModel {
    @observable agentContactId = '';
    @observable referralType = '';
    @observable salesRepresentative = '';
    @observable agentPreferences = '';
    @observable preferredEmail = '';
    @observable brokeragePreferences = '';
    @observable subscriberId = '';

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/agent-profile/agent-profile-view-model.js